import { useContext, useState } from 'react';
import { SessionContext } from '../../Contexts/SessionContext';
import SiteTable from '../../Site/SiteTable/SiteTable';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import SitePickerDialog from '../../Site/SitePages/SitePickerDialog';
import SiteFilterDialog from '../../Site/SitePages/SiteFilterDialog';
import SiteFilterViewModel from '../ViewModels/SiteFilterViewModel';

interface IProps {
}

export default function SiteFiltering({ }: IProps) {
    const { updateSessionState, sessionState } = useContext(SessionContext);
    const [manualSelectorOpen, setManualSelectorOpen] = useState<boolean>(false);
    const [filterOpen, setFilterOpen] = useState<boolean>(false);
    const [filter, setFilter] = useState<SiteFilterViewModel>(new SiteFilterViewModel());

    return (
        <Paper>
            <Grid container spacing={1}>
                <Grid size={4}>
                    <Button onClick={() =>
                        updateSessionState({
                            landusePage: {
                                ...sessionState.landusePage,
                                isAllSelected: !sessionState.landusePage.isAllSelected,
                                sites: []
                            },
                        })
                    }>
                        Select All
                    </Button>
                </Grid>
                <Grid size={4}>
                    <Button sx={{ verticalAlign: 'text-bottom' }} onClick={() => setManualSelectorOpen(true)} variant="contained">Select By Reference</Button>
                </Grid>
                <Grid size={4}>
                    <Button sx={{ verticalAlign: 'text-bottom' }} onClick={() => setFilterOpen(true)} variant="contained">Add Filters</Button>
                </Grid>
            </Grid>
            <SiteTable filter={filter} type={'siteFiltering'} />

            <SitePickerDialog open={manualSelectorOpen} onClose={() => setManualSelectorOpen(false)} />
            {filterOpen &&
                <SiteFilterDialog open={filterOpen} onClose={() => setFilterOpen(false)} setFilter={setFilter} />
            }
        </Paper>
    );
}
